import { FieldNames } from '@app/origami-api/constants/field-names';
import { ServiceOffering } from '@app/origami-api/models/room-type';
import { Topic, TopicUtils } from '@app/origami-api/utils/topic-utils';

export const EVENT_MANAGEMENT_SERVICE_OFFERING_SHORT_NAMES = ['CCR', 'CWS', 'eTMF', 'SSU'];

export function isEventManagementSupportedByServiceOffering(
  offering: string | null | undefined,
): boolean {
  return (
    !!offering &&
    EVENT_MANAGEMENT_SERVICE_OFFERING_SHORT_NAMES.includes(offering)
  );
}

export function mapServiceOfferingFromTopic(topic: Topic): ServiceOffering {
  const topicFields = topic.TopicFields ?? [];

  return {
    id: topic.TopicId ?? 0,
    LongName: topic.TopicName,
    ShortName: TopicUtils.getTopicFieldValue(topicFields, FieldNames.ServiceOffering.Offering) ?? '',
    Color: TopicUtils.getTopicFieldValue(topicFields, FieldNames.ServiceOffering.Color) ?? undefined,
  };
}
